import { Component, Input } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { CalendarService } from '../../../services/calendar.service';
import { TimeSlotEvent } from '../../calendar/day-view-calendar/day-view-calendar.component';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'smr-booking-form-date-change',
  templateUrl: './booking-form-date-change.page.html',
  styleUrls: ['./booking-form-date-change.page.scss'],
})
export class BookingFormDateChangePage {

  public stylistID: number;

  public readOnlyStylistPicker: boolean;

  @Input() promise: Function;

  @Input() isModal: boolean;

  @Input() currentDate: Date;

  public bookingID: number;

  constructor (
      private userService: UserService,
      private calendarService: CalendarService,
      private route: ActivatedRoute,
      private modalCtrl: ModalController,
    ) {
    this.route.queryParams.subscribe(params => {
          this.promise = params["promise"];
          this.currentDate = params["currentDate"];
          this.bookingID = params["bookingID"];
      });
        
    this.readOnlyStylistPicker = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
        this.stylistID = this.calendarService.getBookingCalendarViewStylist().id;
      } else {
        this.readOnlyStylistPicker = true;
        this.stylistID = user.id;
      }
    }
  }

  public onTimeSelected (timeslot: TimeSlotEvent) {
    this.modalCtrl.dismiss(timeslot)
  }
}
